import React, { useState, useEffect, useCallback } from 'react';
import { yonetim } from '../api';

export default function Raporlar() {
  const [kayitlar, setKayitlar] = useState([]);
  const [imlec, setImlec] = useState(null);
  const [dahaVar, setDahaVar] = useState(false);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState('');

  const yukle = useCallback(async (mevcutImlec) => {
    setHata('');
    setYukleniyor(true);
    try {
      const d = await yonetim.kampanyaTiklamaRaporu(mevcutImlec);
      setKayitlar((o) => (mevcutImlec ? [...o, ...d.kayitlar] : d.kayitlar));
      setImlec(d.sonrakiImlec);
      setDahaVar(!!d.sonrakiImlec);
    } catch (e) {
      setHata(e.message);
    } finally {
      setYukleniyor(false);
    }
  }, []);

  useEffect(() => { yukle(null); }, [yukle]);

  return (
    <div>
      <div className="page-header">
        <h1>Raporlar</h1>
        <p>Kampanya tıklanma raporu</p>
      </div>

      {hata && <div className="mesaj hata">{hata}</div>}

      <div className="card tablo-kart">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Kampanya</th>
              <th>Kuyumcu</th>
              <th style={{ textAlign: 'right' }}>Toplam tıklama</th>
              <th style={{ textAlign: 'right' }}>Tekil kullanıcı</th>
            </tr>
          </thead>
          <tbody>
            {kayitlar.map((r) => (
              <tr key={r.kampanyaId}>
                <td>{r.kampanyaId}</td>
                <td><strong>{r.baslik}</strong></td>
                <td>{r.kuyumcuAdi}</td>
                <td style={{ textAlign: 'right', fontWeight: 700 }}>{r.toplamTiklama}</td>
                <td style={{ textAlign: 'right' }}>{r.tekilKullanici}</td>
              </tr>
            ))}
            {!yukleniyor && kayitlar.length === 0 && <tr><td colSpan={5} className="bos">Henüz tıklanma verisi yok.</td></tr>}
            {yukleniyor && kayitlar.length === 0 && <tr><td colSpan={5} className="yukleniyor">Yükleniyor…</td></tr>}
          </tbody>
        </table>
      </div>

      {dahaVar && (
        <div style={{ textAlign: 'center' }}>
          <button className="btn btn-gray" disabled={yukleniyor} onClick={() => yukle(imlec)}>
            {yukleniyor ? 'Yükleniyor…' : 'Daha fazla yükle'}
          </button>
        </div>
      )}
    </div>
  );
}
